import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Componentes
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import ItemList from '../../components/ItemList/ItemList';
import FriendlyPhrase from '../../components/FriendlyPhrase/FriendlyPhrase';

// Contextos
import { useToast } from '../../contexts/ToastContext';
import { useLoader } from '../../contexts/LoaderContext';
import { useModal } from '../../contexts/ModalContext';

// API
import { useUsuarioService } from '../../services/usuarioServices';

// Estilos
import styles from './userspage.module.css';

function UsersPage() {
    const navigate = useNavigate();

    const { showToast } = useToast();
    const { showModal } = useModal();
    const { showLoader, hideLoader } = useLoader();

    const { obterUsuarioPorNome, deletarUsuario, listarTodosUsuarios } = useUsuarioService();

    const [users, setUsers] = useState([]);

    useEffect(() => {
        const carregarUsuarios = async () => {
            showLoader("Carregando usuários");

            const response = await listarTodosUsuarios();

            if (response.success) {
                const dadosFormatados = response.data.map((usuario) => ({
                    id: usuario.id,
                    name: usuario.nome,
                }));

                setUsers(dadosFormatados);
            } else {
                showToast('Erro ao carregar usuários: ' + (response.message || ''), 3000, 'error');
            }

            hideLoader();
        };

        carregarUsuarios();
    }, []);

    const handleEditar = (item) => {
        navigate(`/usuarios/atualizar/${item.id}`);
    };

    const handleExcluir = (item) => {
        showModal(
            `Excluir ${item.name}?`,
            'Essa ação não poderá ser desfeita.',
            async () => {
                showLoader("Excluindo usuário");

                const response = await deletarUsuario(item.id);

                if (response.success) {
                    showToast('Usuário excluído com sucesso!', 3000, 'success');
                    setUsers((prev) => prev.filter((u) => u.id !== item.id));
                } else {
                    showToast('Erro ao excluir usuário.', 3000, 'error');
                    console.error(response.message);
                }

                hideLoader();
            },
            () => {
                showToast('Exclusão cancelada.', 2000);
            }
        );
    };

    const handleAdd = () => {
        navigate(`/usuarios/adicionarUsuario`);
    };

    const handleSelecionar = (item) => {
        console.log("Usuário selecionado:", item);
    };

    console.log(users);

    return (
        <div className={styles.UsersPage}>
            <div className={styles.containerTop}>
                <Breadcrumbs />

                <h1 className={styles.title}>
                    Usuários Cadastrados
                </h1>

                <FriendlyPhrase page="usuarios" />
            </div>

            <div className={styles.containerList}>
                <ItemList
                    items={users}
                    onAdd={handleAdd}
                    onEdit={handleEditar}
                    onDelete={handleExcluir}
                    onClickItem={handleSelecionar}
                />
            </div>
        </div>
    );
}

export default UsersPage;